import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.css']
})
export class ModalWindowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
